import React from 'react'

import AddIcon from 'Assets/Images/icons/add'
import UploadIcon from 'Assets/Images/icons/upload'

export const ButtonAddWithLabelUnstyled = ({
  id,
  className,
  onClickHandler,
  label,
  icon = 'add',
}) => (
  <button id={id} className={className} onClick={onClickHandler}>
    <label>{label}</label>
    {icon === 'upload' ? <UploadIcon isNew={true} /> : <AddIcon />}
  </button>
)
